/**
 * 63.1n with 67.75 (core/motorPoolStock.ts): why a side can't take a vehicle of a kind from its motor pool now — the rule
 * an unpack and a called APC drop share (core/dropship.ts). Its own module: the dropship reads it without the pool's plan
 * (core/motorPool.ts, whose template the dropship's own imports are still loading).
 */
import type { GameState, VehicleKind } from '../types';
import { structureTeam } from './body';

const KIND_WORDS: Record<VehicleKind, string> = { motorcycle: 'bike', wheeled: '6×6', technical: 'technical', supplyTruck: 'supply truck', tracked: 'M113', tank: 'tank' };

/** Whether `team` has a motor pool (the switch on, its pool laid). */
export function poolOf(state: Pick<GameState, 'motorPools'>, team: number) {
  return state.motorPools?.[team] ?? null;
}

/** How many of `team`'s `kind` are out: standing, and on its pad being unpacked. */
function out(state: GameState, team: number, kind: VehicleKind): number {
  let n = 0;
  for (const s of state.structures) if (s.type === kind && s.health > 0 && structureTeam(state, s) === team) n++;
  return n + (state.motorPools?.[team]?.unpacking?.kind === kind ? 1 : 0);
}

/** The refusal while the pad is unpacking another (a flight's frame is not unpacked there: it does not wait on it). */
export const PAD_BUSY = 'The pad is busy';

/** Why `team` can't unpack a `kind` now (null: it can): no pool, none of the kind in it, all of its kind out (the one on the pad counted), the pad busy. */
export function unpackRefusal(state: GameState, team: number, kind: VehicleKind): string | null {
  const pool = poolOf(state, team);
  if (!pool) return 'No motor pool';
  const stock = state.vehicleStocks?.[team]?.[kind];
  if (!stock || stock.left <= 0) return `The motor pool holds no ${KIND_WORDS[kind]}`;
  if (out(state, team, kind) >= stock.cap) return `Every ${KIND_WORDS[kind]} is out`;
  if (pool.unpacking) return PAD_BUSY;
  return null;
}

